import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUrl } from "../apiUrl";
import { AiOutlineSafety } from "react-icons/ai";
import _ from "lodash";


//Obtener toda la data de la tabla resultado
export const getAllResultados = createAsyncThunk(
  "resultados/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${apiUrl}/api/v1/resultado`);

      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
)

//Obtener todos los resultados de auerdo a cita
export const getAllResultadosByCita = createAsyncThunk(
  "resultados/getAllByCita",
  async (cita_id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${apiUrl}/api/v1/resultado/cita/${cita_id}`)
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
)

// POST /resultado/registrar/{id}
export const registrarResultado = createAsyncThunk(
  "resultado/registo",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${apiUrl}/api/v1/resultado/registrar`,
        data
      );
      return response.data.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

//DELETE elimin los resultados de acuerdo al atributo orden_lab
export const eliminarResultadosByOrden = createAsyncThunk(
  "resultados/eliminar",
  async ({ orden_lab, cita_id }, { rejectWithValue }) => {
    try {
      await axios.delete(`${apiUrl}/api/v1/resultado/eliminar/${orden_lab}/${cita_id}`)
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
)

const resultadoSlice = createSlice({
  name: "resultado",
  initialState: {
    data: [],
    registrado: null,
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      //listalos toda la informacion de la tabla resultados
      .addCase(getAllResultados.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getAllResultados.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getAllResultados.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload || {
            message: 'Fallo al cargar los resultados'
          }
      })

      //lista losresultados de acuerdo a una cita
      .addCase(getAllResultadosByCita.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getAllResultadosByCita.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getAllResultadosByCita.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload || {
            message: 'Fallo al cargar los resultados de la cita seleccionada'
          }
      })


      //registra resultados
      .addCase(registrarResultado.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(registrarResultado.fulfilled, (state, action) => {
        state.isLoading = false;
        state.registrado = action.payload;
      })
      .addCase(registrarResultado.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload || {
            message: "Fallo al registrar el resultado",
          };
      })

      //eliminar Resultados
      .addCase(eliminarResultadosByOrden.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(eliminarResultadosByOrden.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = state.data.filter(res => res.orden_lab !== action.payload)
      })
      .addCase(eliminarResultadosByOrden.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || {
          message: "Error al eliminar los resultados de la orden de lab"
        }
      })
  }
});

export const { resetResultado } = resultadoSlice.actions;
export default resultadoSlice.reducer;
